export const initialState = {
	dataSets: {},
	minutesAgo: 0,
	pageRefreshTime: new Date(),
	isLoading: false,
	isPriceLoading: false,
	isProductionLoading: false,
	warning: null,
	error: null,
};

const updateLoadingStates = (state, dataType) => {
	const newProductionLoading = dataType === "general" ? false : (dataType === "production" ? false : state.isProductionLoading);
	const newPriceLoading = dataType === "general" ? false : (dataType === "price" ? false : state.isPriceLoading);

	return {
		...state,
		isProductionLoading: newProductionLoading,
		isPriceLoading: newPriceLoading,
		isLoading: newProductionLoading && newPriceLoading,
	};
};

export const reducer = (state, action) => {
	switch (action.type) {
		case "FETCH_START": {
			return {
				...state,
				isLoading: true,
				isPriceLoading: true,
				isProductionLoading: true,
				warning: null,
				error: null,
				dataSets: {},
			};
		}

		case "FETCH_PRICE_START": {
			return {
				...state,
				isPriceLoading: true,
				isProductionLoading: false,
				isLoading: false,
				warning: null,
				error: null,
				dataSets: {
					...state.dataSets,
					pricesTimeline: undefined,
					periodPrices: undefined,
					monthlyPrices: undefined,
					maxPrice: undefined,
				},
			};
		}

		case "FETCH_PRODUCTION_START": {
			return {
				...state,
				isProductionLoading: true,
				isPriceLoading: false,
				isLoading: false,
				warning: null,
				error: null,
				dataSets: {
					...state.dataSets,
					productProduction: undefined,
					maxProduction: undefined,
				},
			};
		}

		case "FETCH_SUCCESS": {
			const { plotId, response, dataType } = action.payload;
			return {
				...state,
				...updateLoadingStates(state, dataType),
				error: null,
				dataSets: {
					...state.dataSets,
					[plotId]: response,
				},
				pageRefreshTime: new Date(),
				minutesAgo: 0,
			};
		}

		case "FETCH_WARNING": {
			const { plotId, response, dataType, warning } = action.payload;
			return {
				...state,
				...updateLoadingStates(state, dataType),
				warning,
				dataSets: {
					...state.dataSets,
					[plotId]: response,
				},
				pageRefreshTime: new Date(),
				minutesAgo: 0,
			};
		}

		case "FETCH_ERROR": {
			return {
				...state,
				isLoading: false,
				error: action.payload?.error || "An error occurred",
			};
		}

		case "CACHE_RESTORE": {
			return {
				...state,
				isLoading: false,
				isPriceLoading: false,
				isProductionLoading: false,
				dataSets: action.payload.dataSets,
				minutesAgo: action.payload.minutesAgo,
			};
		}

		case "UPDATE_MINUTES_AGO": {
			if (!state.pageRefreshTime) return state;

			const minutesAgo = Math.floor((Date.now() - state.pageRefreshTime) / 60_000);

			return {
				...state,
				minutesAgo,
			};
		}

		default: {
			return state;
		}
	}
};